@if(checklistData && checklistData.length > 0) {
@for(checkList of checklistData; track $index) {
<div class="mb-2">
    <nz-collapse [nzExpandIconPosition]="'end'"
        [ngClass]="checkList.isCompleted ? 'completed completed-ant-collapse' : 'pending pending-ant-collapse'">
        <nz-collapse-panel [nzActive]="isPanelActive(checkList)" (nzActiveChange)="onPanelActiveChange($event, checkList)" [nzHeader]="associationHeader">

            <ng-template #associationHeader>
                <div class="checklist-header-item" tabindex="0"
                (keydown.enter)="onPanelHeaderKeyPress(checkList)">
                    <div>
                        @if(checkList.isCompleted) {<i class="fa fa-check-circle medium-icon-size"
                            aria-hidden="true"></i> }
                        {{checkList.checklistName}}
                    </div>
                    <div>
                        {{checkList.totalItemsCompleted +'/'+checkList.children.length}} Completed
                    </div>
                </div>
            </ng-template>
            <div [attr.inert]="!isPanelActive(checkList) ? '' : null" [attr.aria-hidden]="!isPanelActive(checkList) ? 'true' : null">
            @for(categories of checkList.children; track $index) {
            <nz-collapse [nzExpandIconPosition]="'end'"
                [ngClass]="categories.isCompleted ? 'completed completed-ant-collapse' : 'pending pending-ant-collapse'">
                <nz-collapse-panel [nzActive]="isPanelActive(categories)" (nzActiveChange)="onPanelActiveChange($event, categories)" [nzHeader]="categoryHeader">

                    <ng-template #categoryHeader>
                        <div class="checklist-header-item" tabindex="0"
                        (keydown.enter)="onPanelHeaderKeyPress(categories)">
                            <div>
                                @if(categories.isCompleted) {<i class="fa fa-check-circle medium-icon-size"
                                    aria-hidden="true"></i> }
                                {{categories.checklistName}}
                            </div>
                            <div>
                                {{categories.totalItemsCompleted +'/'+categories.totalItems}} Completed
                            </div>
                        </div>
                    </ng-template>
                    <div [attr.inert]="!isPanelActive(categories) ? '' : null" [attr.aria-hidden]="!isPanelActive(categories) ? 'true' : null">
                    @for(checklistItem of categories.items; track $index) {
                    <div class="mb-3 checklist-question" role="group" [attr.aria-labelledby]="'q_' + checklistItem.checklistItemId">
                        <div class="question-text" [attr.id]="'q_' + checklistItem.checklistItemId">
                            @if(checklistItem.checkListStatus && checklistItem.checkListStatus === 'C') {<i
                                class="primary-icon fa fa-check-circle medium-icon-size" aria-hidden="true"></i> }
                            {{checklistItem.question}}?
                        </div>
                        @switch(checklistItem.fieldType) {
                        @case ("radio"){
                        <div class="question-body">
                            <nz-radio-group [(ngModel)]="checklistItem.value" class="ppl-radio-group" [disabled]="checklistItem.readonly || (checklistItem.isHRQuestion && !HREdit)" [attr.aria-labelledby]="'q_' + checklistItem.checklistItemId">
                                @for(opt of radioOptions; track $index){
                                <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                                }
                            </nz-radio-group>
                        </div>
                        }
                        @case ("text"){
                        <div class="question-body">
                            <input nz-input [(ngModel)]="checklistItem.value" type="{{checklistItem.dataType}}" [disabled]="checklistItem.readonly || (checklistItem.isHRQuestion && !HREdit)"
                                [placeholder]="showPlaceholderForIds.includes(checklistItem?.checklistItemId) ? '\u00A0' : checklistItem.question "
                                [attr.aria-labelledby]="'q_' + checklistItem.checklistItemId"  [attr.max]="checklistItem.question === 'E-Verify Processed Date' ? today : null"
                                (ngModelChange)="validateDate($event, checklistItem)"/>
                                @if(dateError && checklistItem.question === 'E-Verify Processed Date') {
                                    <span style="color: red">Date cannot be later than today.</span>
                                }
                            </div>
                        }
                        @case ("label"){
                        <div class="question-body" [attr.aria-labelledby]="'q_' + checklistItem.checklistItemId">
                            {{checklistItem.value}}
                        </div>
                        }
                        @case ("dropdown") {
                        <div class="question-body">
                            <ppl-dropdown-select
                            [(ngModel)]="checklistItem.value"
                            [disabled]="checklistItem.readonly || (checklistItem.isHRQuestion && !HREdit)"
                            [options]="checklistItem.lookupValue"
                            [optionLabel]="'value'"
                            [optionValue]="'key'"
                            (ngModelChange)="onDropdownValueChange(checklistItem)"
                            [placeholder]="showPlaceholderForIds.includes(checklistItem?.checklistItemId) ? '\u00A0' : checklistItem.question "
                            [attr.aria-labelledby]="'q_' + checklistItem.checklistItemId">
                            </ppl-dropdown-select>
                        </div>
                        }

                        @case ("date"){
                        <div class="question-body">
                            <nz-date-picker style="height: 32px;" [(ngModel)]="checklistItem.value" [disabled]="checklistItem.readonly || (checklistItem.isHRQuestion && !HREdit)"
                                [nzFormat]="'MM/dd/yyyy'"></nz-date-picker>
                        </div>
                        }
                        }
                        @if(checklistItem.showDateRange && checklistItem.checklistItemId === 91) {
                            <div class="question-date-picker ml-4">
                              <input nz-input [(ngModel)]="checklistItem.toDate" type="date"
                              [attr.aria-labelledby]="'q_' + checklistItem.checklistItemId" [attr.min]= "today"
                              (ngModelChange)="validateExpirationDate($event)"/>
                              <div class="error-container">
                                @if (expirationDateError) {
                                  <p class="error-text">Expiration Date can be today or in future.</p>
                                }
                                @else if (showSaveError) {
                                    <p class="error-text">Expiration Date is mandatory.</p>
                                  }
                              </div>
                            </div>
                        }
                        @if(checklistItem.showDateRange && checklistItem.checklistItemId !== 91) {
                        <div class="question-body ml-4">

                            <nz-range-picker nzFormat="yyyy-MM-dd" [(ngModel)]="checklistItem.dateRange" [disabled]="checklistItem.readonly || (checklistItem.isHRQuestion && !HREdit)"
                                (ngModelChange)="onChange($event, checklistItem)"></nz-range-picker>
                        </div>

                        }

                        @if(checklistItem.formMasterId !== 0) {
                        <div class="question-form question-body ml-4">

                            <ppl-button label="View Form" [ariaLabel]="getAriaLabel(checklistItem)" icon="fa fa-file-text" [customClass]="'alt-button'"
                                [iconPosition]="'right'" (click)="handleCheckListClick(checklistItem)"></ppl-button>
                        </div>
                        }
                    </div>
                    }

                    @for(subCategories of categories.children; track $index) {
                    <nz-collapse [nzExpandIconPosition]="'end'"
                        [ngClass]="subCategories.isCompleted ? 'completed completed-ant-collapse' : 'pending pending-ant-collapse'">
                        <nz-collapse-panel [nzActive]="isPanelActive(subCategories)" (nzActiveChange)="onPanelActiveChange($event, subCategories)" [nzHeader]="subCategoryHeader">


                            <ng-template #subCategoryHeader>
                                <div class="checklist-header-item">
                                    <div>
                                        @if(subCategories.isCompleted) {<i class="fa fa-check-circle medium-icon-size"
                                            aria-hidden="true"></i> }
                                        {{subCategories.checklistName}}
                                    </div>
                                    <div>
                                        {{subCategories.totalItemsCompleted +'/'+subCategories.totalItems}}
                                        Completed
                                    </div>
                                </div>
                            </ng-template>
                            <div [attr.inert]="!isPanelActive(subCategories) ? '' : null" [attr.aria-hidden]="!isPanelActive(subCategories) ? 'true' : null">
                            @for(checklistItem of subCategories.items; track $index) {
                            <div class="mb-3 checklist-question" role="group" [attr.aria-labelledby]="'q_' + checklistItem.checklistItemId">
                                <div class="question-text" [attr.id]="'q_' + checklistItem.checklistItemId">
                                    @if(checklistItem.checkListStatus && checklistItem.checkListStatus === 'C') {<i
                                        class="primary-icon fa fa-check-circle medium-icon-size" aria-hidden="true"></i>
                                    } {{checklistItem.question}}?
                                </div>
                                @switch(checklistItem.fieldType) {
                                @case ("radio"){
                                <div class="question-body">
                                    <nz-radio-group [(ngModel)]="checklistItem.value" class="ppl-radio-group" [disabled]="checklistItem.readonly || (checklistItem.isHRQuestion && !HREdit)" [attr.aria-labelledby]="'q_' + checklistItem.checklistItemId">
                                        @for(opt of radioOptions; track $index){
                                        <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                                        }
                                    </nz-radio-group>
                                </div>
                                }
                                @case ("text"){
                                <div class="question-body">
                                    <input nz-input [(ngModel)]="checklistItem.value" type="{{checklistItem.dataType}}" [disabled]="checklistItem.readonly || (checklistItem.isHRQuestion && !HREdit)"
                                    [placeholder]="showPlaceholderForIds.includes(checklistItem?.checklistItemId) ? '\u00A0' : checklistItem.question "
                                    [attr.aria-labelledby]="'q_' + checklistItem.checklistItemId" />
                                </div>
                                }
                                @case ("label"){
                                <div class="question-body" [attr.aria-labelledby]="'q_' + checklistItem.checklistItemId">
                                    {{checklistItem.value}}
                                </div>
                                }
                                @case ("dropdown") {
                                <div class="question-body">
                                    <ppl-dropdown-select
                                    [(ngModel)]="checklistItem.value"
                                    [disabled]="checklistItem.readonly || (checklistItem.isHRQuestion && !HREdit)"
                                    [options]="checklistItem.lookupValue"
                                    [optionLabel]="'value'"
                                    [optionValue]="'key'"
                                    [placeholder]="showPlaceholderForIds.includes(checklistItem?.checklistItemId) ? '\u00A0' : checklistItem.question "
                                    [attr.aria-labelledby]="'q_' + checklistItem.checklistItemId">
                                    </ppl-dropdown-select>
                                </div>
                                }

                                @case ("date"){
                                <div class="question-body">
                                    <nz-date-picker [(ngModel)]="checklistItem.value" style="height: 32px;" [disabled]="checklistItem.readonly || (checklistItem.isHRQuestion && !HREdit)"
                                        [nzFormat]="'MM/dd/yyyy'"></nz-date-picker>
                                </div>
                                }
                                }

                                @if(checklistItem.showDateRange) {
                                <div class="question-body ml-4">
                                    <nz-range-picker nzFormat="yyyy-MM-dd" [(ngModel)]="checklistItem.dateRange" [disabled]="checklistItem.readonly || (checklistItem.isHRQuestion && !HREdit)"
                                        (ngModelChange)="onChange($event, checklistItem)"></nz-range-picker>
                                </div>
                                }

                                @if(checklistItem.formMasterId !== 0) {
                                <div class="question-form question-body ml-4">
                                    <ppl-button label="View Form" [ariaLabel]="getAriaLabel(checklistItem)" icon="fa fa-file-text" [customClass]="'alt-button'"
                                        [iconPosition]="'right'"
                                        (click)="handleCheckListClick(checklistItem)"></ppl-button>
                                </div>
                                }
                            </div>
                            }
                            </div>
                        </nz-collapse-panel>
                    </nz-collapse>
                    <span class="mt-1">&nbsp;</span>
                    }
                    </div>
                </nz-collapse-panel>
            </nz-collapse>
            <span class="mt-1">&nbsp;</span>
            }
            </div>
        </nz-collapse-panel>
    </nz-collapse>
</div>
}
}
@else if (showNoRecordsMesssage){
<nz-alert class="mb-2" nzType="info" [nzMessage]="message" nzShowIcon></nz-alert>
}